import React from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";

const JavaScriptCyberOutline = () => {
  return(
  <HTMLCourseNavProvider>
   <div className="container">
    <div className="row">
        <div>
            <SideBar />
        </div>
        <div className="col-md-12">
            <h3><strong>Course Outline</strong></h3>
            <ol className="list-group list-group-numbered">
                <li className="list-group-item"><Link className="text-primary" to="/cyber-script-introduction">Introduction to cybersecurity: Concepts, threats, and challenges</Link></li>
                <li className="list-group-item"><Link className="text-primary" to="/cyber-script-role">Role of JavaScript in Cybersecurity</Link></li>


            </ol>
            <div style={{ height: '45vh'}} />
        </div>
    </div>
</div>

    </HTMLCourseNavProvider>
  )
}

export default JavaScriptCyberOutline
